import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { ASSESSMENT_FORMATIVE_CREATE, ASSESSMENT_FORMATIVE_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const assessmentFormativeCreate = createAsyncThunk(
  ASSESSMENT_FORMATIVE_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.ASSESSMENT_FORMATIVE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.assessmentFormativeCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentFormativeList = createAsyncThunk(
  ASSESSMENT_FORMATIVE_LIST,
  async (params: PayloadCreatorParams<`${typeof API.ASSESSMENT_FORMATIVE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.assessmentFormativeList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentFormativeListClear = createAction(`${ASSESSMENT_FORMATIVE_LIST}/clear`)
